export const IconCrossCancel20: {
  name: 'icon_cross_cancel_20-7d8c42b749b2'
} = {
  name: 'icon_cross_cancel_20-7d8c42b749b2'
}
